export interface FeatureFlagInfo {
  flagName: string;
  localStorageName: string;
}

export const FEATURE_FLAG_MAP = {
  SCHEDULER_V3_UI: {
    flagName: 'scheduler-v3-ui',
    localStorageName: 'weave.scheduler-v3-ui-ff-override',
  },
  OPERATORY_V3: {
    flagName: 'schedule:operatory-v3',
    localStorageName: 'weave.operatory-v3-ff-override',
  },

  SCHEDULE_WAITLIST: {
    flagName: 'schedule:waitlist',
    localStorageName: 'weave.schedule-waitlist-ff-override',
  },
  SCHEDULE_WAITLIST_DIRECT_SCHEDULING: {
    flagName: 'schedule:waitlist:direct_scheduling',
    localStorageName: 'weave.schedule-waitlist-direct-scheduling-ff-override',
  },
  NEW_APPOINTMENT_PANEL_UI: {
    flagName: 'schedule:new-appointment-panel-ui',
    localStorageName: 'weave.schedule-new-appointment-panel-ui-ff-override',
  },
  SCHEDULE_CALENDAR_BLOCK_UI: {
    flagName: 'schedule:calendar-block-ui',
    localStorageName: 'weave.schedule-calendar-block-ui-ff-override',
  },
  SCHEDULE_CALENDAR_COLUMNS_REORDERING: {
    flagName: 'schedule-calendar-columns-reordering',
    localStorageName: 'weave.schedule-calendar-columns-reordering-ff-override',
  },
} as const satisfies Record<string, FeatureFlagInfo>;

export type FeatureFlagKey = keyof typeof FEATURE_FLAG_MAP;
